<template>
    <aside ref="panelRef" class="edge-panel-wrapper" :class="{ 'is-active': isOpen }"
        :style="{ '--panel-width': width }">
        <div class="panel-content">
            <div class="mobile-handle md:hidden" @click="isOpen = false"></div>

            <div class="panel-card">
                <slot></slot>
            </div>
        </div>

        <div class="panel-trigger" :class="{ 'trigger-hidden': isOpen }" @click="toggle">
            <div class="icon-container">
                <slot name="icon">
                    <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                </slot>
            </div>
        </div>
    </aside>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
    width: { type: String, default: '450px' }
});

const isOpen = ref(false);
const panelRef = ref(null);

const toggle = () => { isOpen.value = !isOpen.value; };

const handleClickOutside = (event) => {
    if (isOpen.value && panelRef.value && !panelRef.value.contains(event.target)) {
        isOpen.value = false;
    }
};

onMounted(() => document.addEventListener('click', handleClickOutside));
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
</script>

<style scoped>
/* 基础容器 */
.edge-panel-wrapper {
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 0;
    display: flex;
    align-items: center;
    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    /* 初始隐藏：根据传入的宽度向左完全偏移 */
    transform: translate(calc(-1 * var(--panel-width)), -50%);
}

/* 激活状态：滑入并留出 20px 呼吸感 */
.edge-panel-wrapper.is-active {
    transform: translate(20px, -50%);
}

/* 内容区域 */
.panel-content {
    width: var(--panel-width);
    flex-shrink: 0;
    /* 防止内容被压缩 */
}

.panel-card {
    width: 100%;
}

/* 触发按钮：它必须挂在容器的最右侧 */
.panel-trigger {
    width: 52px;
    height: 52px;
    background: white;
    @apply shadow-[10px_0_30px_rgba(0,0,0,0.05)] border border-gray-100 border-l-0;
    border-radius: 0 1rem 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    /* 关键点：通过绝对定位让它永远贴在容器右边界并露出来 */
    position: absolute;
    right: -52px;

    transition: all 0.4s ease;
    color: #9ca3af;
}

/* 展开后隐藏按钮 */
.panel-trigger.trigger-hidden {
    opacity: 0;
    pointer-events: none;
    transform: translateX(-20px);
}

/* 悬停反馈 */
.panel-trigger:hover {
    background: #f0f7ff;
    color: #1e90ff;
}

/* --- 移动端简单适配：如果屏幕太窄，直接隐藏或缩小 --- */
@media (max-width: 640px) {
    .edge-panel-wrapper {
        --panel-width: 90vw !important;
        /* 手机上占满屏幕 90% */
    }

    .panel-trigger {
        width: 44px;
        height: 44px;
        right: -44px;
    }
}
</style>
